
let requestHandleFunc = function (request) {
    if (/\/Database\/coupon_component/.test(request.url)) {

    }
    return request;
};

export default requestHandleFunc;



// WEBPACK FOOTER //
// ./example/app/request.js